import moment from "moment";
import { Grid, GridItem } from "@chakra-ui/react";
import { MdOutlineDelete } from "react-icons/md";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useMemo } from "react";
import withReducer from "services/withReducer";
import PrimaryButton from "components/button/primary_button";
import Card from "../components/card";
import reducer from "../store";
import "./calendar.scss";
import SelectFood from "../components/selectFood";
import { deleteCalendarFood } from "../store/calendarSlice";

import {
  setFilters,
  getCalendarData,
  getCalendarList,
  getCourseOptions,
  getFoodOptions,
  setOpenModal,
} from "../store/calendarSlice";

const dayMap = {
  Даваа: 1,
  Мягмар: 2,
  Лхагва: 3,
  Пүрэв: 4,
  Баасан: 5,
};

const monthMap = {
  0: "1-р сар",
  1: "2-р сар",
  2: "3-р сар",
  3: "4-р сар",
  4: "5-р сар",
  5: "6-р сар",
  6: "7-р сар",
  7: "8-р сар",
  8: "9-р сар",
  9: "10-р сар",
  10: "11-р сар",
  11: "12-р сар",
};

const FoodCalendar = () => {
  const dispatch = useDispatch();
  const filters = useSelector(({ food }) => food.calendarSlice.filters);
  const courseOptions = useSelector(
    ({ food }) => food.calendarSlice.courseOptions
  );

  const data = useSelector(getCalendarData);

  useEffect(() => {
    dispatch(getCourseOptions());
    dispatch(getFoodOptions());
  }, [dispatch]);

  // Calendar iin data tatna
  useEffect(() => {
    if (filters.course) {
      const payload = {
        a: filters.course,
        m: filters.month + 1,
      };
      dispatch(getCalendarList(payload));
    }
  }, [dispatch, filters.month, filters.course]);

  // Function to calculate all selected days (e.g., Mondays, Tuesdays, etc.) in the selected month and year
  const days = useMemo(() => {
    const year = new Date().getFullYear();
    const selectedDayNumber = dayMap[filters.day]; // Get the number for the selected day

    let daysList = [];
    let date = new Date(year, filters.month, 1); // Start on the 1st of the selected month

    // Loop through the days in the month
    while (date.getMonth() === filters.month) {
      if (date.getDay() === selectedDayNumber) {
        // Check if it's the selected day
        daysList.push(new Date(date)); // Add to the list
      }
      date.setDate(date.getDate() + 1); // Move to the next day
    }

    return daysList;
  }, [filters.day, filters.month]); // Recalculate when the selected day or month changes

  const selectMonth = () => {
    return (
      <div className="flex gap-4">
        <select
          className="custom-select"
          value={filters.course}
          onChange={(e) => {
            dispatch(setFilters({ ...filters, course: e.target.value }));
          }}
        >
          {courseOptions.map((options) => (
            <option key={options.id} value={options.id}>
              {options.name}
            </option>
          ))}
        </select>

        <select
          className="custom-select"
          value={filters.month}
          onChange={(e) => {
            dispatch(
              setFilters({ ...filters, month: parseInt(e.target.value) })
            );
          }}
        >
          {Object.entries(monthMap).map(([monthNumber, monthName]) => (
            <option key={monthNumber} value={monthNumber}>
              {monthName}
            </option>
          ))}
        </select>

        <select
          className="custom-select"
          value={filters.day}
          onChange={(e) => {
            dispatch(setFilters({ ...filters, day: e.target.value }));
          }}
        >
          <option value="Даваа">Даваа гараг</option>
          <option value="Мягмар">Мягмар гараг</option>
          <option value="Лхагва">Лхагва гараг</option>
          <option value="Пүрэв">Пүрэв гараг</option>
          <option value="Баасан">Баасан гараг</option>
        </select>
      </div>
    );
  };

  const formatDate = (day) => {
    return `${filters.day} гараг /${
      day.getMonth() + 1
    }-р сарын -${day.getDate()}/`;
  };

  const addFood = (day, time) => {
    const payload = {
      open: true,
      date: moment(day).format("YYYY-MM-DD"),
      course: filters.course,
      time,
    };

    dispatch(setOpenModal(payload));
  };

  const deleteButton = (foodId) => {
    return (
      <MdOutlineDelete
        onClick={() => dispatch(deleteCalendarFood(foodId))}
        fontSize={16}
        className="hover:text-red-500"
      />
    );
  };

  return (
    <Card title="Хоолны цэс" actions={selectMonth()}>
      <SelectFood />

      <div className="food-card w-full !bg-white px-6 pb-6 pt-4">
        {days.map((day, index) => {
          const monthData = data.filter(
            (d) => d.date === moment(day).format("YYYY-MM-DD")
          );

          return (
            <div key={index} className="mb-6">
              <div className="text-[11px]">Өдөр</div>
              <div className="mt-[2px] text-[13px] uppercase">
                {formatDate(day)}
              </div>

              <Grid templateColumns="repeat(4, 1fr)" gap={2} className="tses">
                <GridItem w="100%">
                  <div className="content">Өглөө</div>
                  {/* Items render */}
                  {monthData
                    .filter((m) => m.time === 1)
                    .map((item) => {
                      return (
                        <div className="item" key={item.id}>
                          {item.food_name} {deleteButton(item.id)}
                        </div>
                      );
                    })}

                  <PrimaryButton
                    text="+ Нэмэх"
                    cls="w-full !mt-2"
                    onClick={() => addFood(day, 1)}
                  />
                </GridItem>
                <GridItem w="100%">
                  <div className="content">Бага үд</div>
                  {/* Items render */}
                  {monthData
                    .filter((m) => m.time === 2)
                    .map((item) => {
                      return (
                        <div className="item" key={item.id}>
                          {item.food_name} {deleteButton(item.id)}
                        </div>
                      );
                    })}
                  <PrimaryButton
                    text="+ Нэмэх"
                    cls="w-full !mt-2"
                    onClick={() => addFood(day, 2)}
                  />
                </GridItem>
                <GridItem w="100%">
                  <div className="content">Өдөр</div>
                  {/* Items render */}
                  {monthData
                    .filter((m) => m.time === 3)
                    .map((item) => {
                      return (
                        <div className="item" key={item.id}>
                          {item.food_name} {deleteButton(item.id)}
                        </div>
                      );
                    })}
                  <PrimaryButton
                    text="+ Нэмэх"
                    cls="w-full !mt-2"
                    onClick={() => addFood(day, 3)}
                  />
                </GridItem>
                <GridItem w="100%">
                  <div className="content">Их үд</div>
                  {/* Items render */}
                  {monthData
                    .filter((m) => m.time === 4)
                    .map((item) => {
                      return (
                        <div className="item" key={item.id}>
                          {item.food_name} {deleteButton(item.id)}
                        </div>
                      );
                    })}
                  <PrimaryButton
                    text="+ Нэмэх"
                    cls="w-full !mt-2"
                    onClick={() => addFood(day, 4)}
                  />
                </GridItem>
              </Grid>
            </div>
          );
        })}
      </div>
    </Card>
  );
};

export default withReducer("food", reducer)(FoodCalendar);
